import { StringDevUIField } from "./StringDevUIField";

export class StringDevFieldDivider extends StringDevUIField<void> {
  constructor(label?: string) {
    super("", label ?? "", undefined as any, () => {});
  }

  build(): HTMLElement {
    const divider = document.createElement("div");
    divider.setAttribute("data-string-dev-divider", "");

    if (this.label) {
      const text = document.createElement("span");
      text.textContent = this.label;
      text.setAttribute("data-string-dev-divider-label", "");
      divider.appendChild(text);
    }

    this.root = divider;
    return divider;
  }

  setValue(): void {}
}
